module.exports = __webpack_public_path__ + "media/images/flags/SE-1ef36e9f1e91109e644aa66a3b4a1733.svg";